import { Workplace } from './../model/iworkplace';
import { UserProfile } from './../model/i-user-profile';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { firestore } from 'firebase/app';
import { collectionData, docData } from 'rxfire/firestore';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class StaffService {

  db = firestore();
  staffRef = this.db.collection('userProfile');
  staff$ : Observable<any>;

  constructor(
    public authService : AuthService
  ) { 
    
  }

  searchStaff(email : string){
    let staff = this.staffRef.where('email','==', email);
    return this.staff$ = collectionData(staff, 'uid').pipe(
      map(staff=>{
        return staff;
      })
    )
  }

  sendInvitation(rekan: UserProfile, workplace : Workplace){

    return this.staffRef.doc(`${rekan.uid}`).update({
      listInvitation : firestore.FieldValue.arrayUnion({
        uid : this.authService.userProfile.uid,
        displayName : this.authService.userProfile.displayName,
        photoURL : this.authService.userProfile.photoURL,
        workplaceUID : workplace.uid,
        workplaceName : workplace.workplaceName
      }) 
    })    
  }

  removeStaff(rekan: UserProfile, workplace : Workplace){
    console.log("Remove Staff " );
    return this.staffRef.doc(`${rekan.uid}`).update({
      listInvitation : firestore.FieldValue.arrayRemove({
        uid : this.authService.userProfile.uid,
        displayName : this.authService.userProfile.displayName,
        photoURL : this.authService.userProfile.photoURL,
        workplaceUID : workplace.uid,
        workplaceName : workplace.workplaceName
      })
    })
  }



}
